export default __webpack_public_path__ + "static/media/holly-springs.10200b0f.jpg";